export default __webpack_public_path__ + "static/media/43k.ee08075a.md";